import { Filter } from "@planzone/dto";

function eraseFilters(filter: Filter): Filter {
  return Object.entries(filter).reduce(
    (nextFilter, [key, value]) => ({
      ...nextFilter,
      [key]:
        typeof value === "undefined"
          ? undefined
          : Array.isArray(value)
            ? []
            : value,
    }),
    {},
  );
}

export { eraseFilters };
